export const formatLargeNumber = (num: number): string => {
  if (num < 1000) {
    return num.toString();
  }

  const units = ['', 'K', 'M', 'B', 'T'];
  const order = Math.floor(Math.log10(num) / 3);
  const unitIndex = Math.min(order, units.length - 1);
  const value = num / Math.pow(1000, unitIndex);

  // Remove decimal if it's a whole number, otherwise show one decimal place
  const formattedValue = value % 1 === 0 ? value.toFixed(0) : value.toFixed(1);

  return `${formattedValue}${units[unitIndex]}`;
};
